import type { SearchFieldListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';

export function mapOsVersionFieldConfiguration(response: SearchFieldListResponseApi): FieldConfiguration[] {
  return response.map<FieldConfiguration>(({ key, type }) => ({
    key,
    type,
    visible: true,
    searchable: true,
  }));
}
